import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Page from "../../components/Page";
import { ATTICUS_PAGE_PREFIX } from "../../constants";
import { Link } from "react-router-dom";
import { LARAVEL_APP_HOME } from "../../constants";

export const NotFoundView = (): JSX.Element => {
  console.error("user reached 404 screen");

  return (
    <Page
      sx={{
        backgroundColor: "background.default",
        height: "100%",
        py: 3,
      }}
      title={`${ATTICUS_PAGE_PREFIX} - 404`}
    >
      <Box
        display="flex"
        flexDirection="column"
        height="40%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h3" gutterBottom>
              404: The page you are looking for isn’t here
            </Typography>
            <Typography
              sx={{
                mb: 2,
              }}
            >
              You either tried an unknown route or you came here by mistake.
              Please try again.
            </Typography>
            <a href={LARAVEL_APP_HOME}>Or go to Home</a>
          </Box>
        </Container>
      </Box>
    </Page>
  );
};
